import React from "react";
import { buildTranslator, MatrixRadioButtonsFormField } from "../../../../amorg-common";
import { AnswerFieldContext } from "../customFormFieldFactory";
import { RadioButton } from "../../../../designSystem/inputs/RadioButton";
import styled from "styled-components";
import { CustomFormFieldHeader } from "../../[parm]/_components/CustomFormFieldHeader";

import { CustomFormFieldFooter } from "../../[parm]/_components/CustomFormFieldFooter";
import { CustomFormFieldCard } from "../../[parm]/_components/CustomFormFieldCard";

type MatrixRadioButtonsCustomFormFieldComponentProps = AnswerFieldContext & {
    field:MatrixRadioButtonsFormField
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function MatrixRadioButtonsCustomFormFieldComponent(props:MatrixRadioButtonsCustomFormFieldComponentProps):JSX.Element
{

    async function handleChange(value:string)
    {
        await props.onSubmit([{ fieldId: props.field.fieldId, value }]);
        props.doUpdate();
    }

    const answerField = props.answer.selections.find(s => s.fieldId === props.field.fieldId);
    const answerValue = answerField.value;

    const translator = buildTranslator('da');

    return (
        <section>
            
            <CustomFormFieldHeader field={props.field} />
            <CustomFormFieldCard>
            
            {props.field.sections.map((section,sectionIndex) =>{

                const columnLength = section.rows[sectionIndex].options.length;

                return (
                    <div key={sectionIndex}>
                        <MatrixHeader columns={columnLength}>
                            {section.headerCells.map((header, headerIndex) => {
                                return (
                                    <div key={headerIndex}>
                                        <HeaderSingle dangerouslySetInnerHTML={{ __html: translator(header.content) }} />
                                        {header.imageUrl &&
                                        <ImageSingle>
                                            <img src={`/images/ergocheck/${header.imageUrl}`} alt="Image image" />
                                        </ImageSingle>
                                    }
                                    </div>
                                );   
                            })}
                        </MatrixHeader>

                        <>
                        {section.rows.map((r, ri) => {
            
                            return (
                                <MatrixRow key={ri} columns={columnLength}>
                                
                                    <div dangerouslySetInnerHTML={{ __html: translator(r.header)}} />
                                    {r.options.map( (o, optionIndex) => {
                                        return o === null 
                                            ? <div key={optionIndex}></div> 
                                            :(
                                                <MatrixSingleCell key={optionIndex} backgroundColor={o.backgroundColor}>
                                                        
                                                    <RadioButton
                                                        disabled={props.disabled}
                                                        id={props.field.fieldId + '_' + o.value}
                                                        name={props.field.fieldId}
                                                        checked={answerValue === o.value}
                                                        text={translator(o.content)}
                                                        value={o.value}
                                                        onChange={handleChange}
                                                    />
                                                </MatrixSingleCell>
                                             );
                                    })}
                                </MatrixRow>
                            );
                        })}
                        </>
                    </div>
                );
            })}
            
            </CustomFormFieldCard>
            {props.field.footer &&
                <CustomFormFieldFooter text={translator(props.field.footer)} />
            }
        </section>
    );
}

const MatrixHeader = styled.div<{columns?:number}>`
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #ccc;
    
    background-color: ${props => props.theme.colors.customForm.answer.formFieldCard.cardHeader.background};
    color: ${props => props.theme.colors.customForm.answer.formFieldCard.cardHeader.text};
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;

    & > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 0.5rem;
        width: calc(100% / ${props => props.columns || 1});
    }
`

const MatrixRow = styled.div<{columns?:number}>`
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #ccc;
       
    &:last-child {
        border-bottom: none; /* Fjern grænsen på den sidste række */
        padding-bottom: 0;
    }

    & > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 0.5rem;
        width: calc(100% / ${props => props.columns || 1});
    }
    
`

const HeaderSingle = styled.div`
    display: flex;
    flex-grow: 1;
    width: 100%;
    justify-content: center;
    `

const MatrixSingleCell = styled.div<{backgroundColor?:string}>`
    background: ${props => props.backgroundColor || 'transparent'};
    align-items: center;
    justify-content: center !important;

    & label {
        margin-left: 16px;
    }
`


const ImageSingle = styled.div`

    & img{
        width:100%;
        object-fit:cover;
    }
`